<template>
  <b-card class="shadow" style="min-height: 700px" id="printme">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            {{ $t("Todos os Acompanhamentos") }}
          </h5>
          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button variant="outline-dark" @click="print()">
              <i class="fas fa-print"></i>
            </b-button>
            <b-button
              variant="outline-dark"
              @click="exportar()"
              :title="$t('Exportar')"
              v-b-tooltip.hover
            >
              <i class="fas fa-file-excel"></i>
            </b-button>
          </b-button-group>
        </div>
      </div>
      <div class="col-12" v-if="viewFilterReport">
        <!-- Filtros -->
        <form @submit.prevent="getAnalytics" ref="addItem">
          <div class="row">
            <form-select
              v-model="filtroUnidades"
              label="Filtrar por Unidade"
              grid="6"
              :itens="unidades"
              :disabled="desabledSearchUnidade"
              :loading="loadingSearchUnidade"
              @input="getTecnicos"
              multiple
            />

            <form-select
              v-model="filtroTecnicos"
              grid="6"
              label="Filtrar por Técnico Responsável"
              :itens="listtecnicos"
              :disabled="loadingSearchTecnicos"
              :loading="loadingSearchTecnicos"
              multiple
            />

            <form-select
              v-model="filtroTecnicosAutor"
              grid="6"
              label="Filtrar por Técnico Autor"
              :itens="listtecnicos"
              :disabled="loadingSearchTecnicos"
              :loading="loadingSearchTecnicos"
              multiple
            />

            <div class="col-md-8 mb-2">
              <label for="input-search">
                <b>Pesquisar por Nome de Usuário</b>
              </label>
              <b-input
                placeholder="Digite o nome Nome de Usuário e clique em Gerar Relatório "
                class="form-control search-input"
                type="text"
                v-model="search"
              />
            </div>

            <form-select
              v-model="filtroStatus"
              grid="4"
              label="Status"
              :itens="status"
              :loading="loadingStatus"
              :disabled="loadingStatus"
              multiple
            />

            <form-toggle
              v-model="filtrarDatas"
              grid="12"
              label="Filtrar por Datas?"
            />

            <template v-if="filtrarDatas">

              <form-calendar
                v-model="data_inicio"
                grid="6"
                label="Data inicial do acompanhamento"
                :max-date="dataNow"
              />

              <form-calendar
                v-model="data_fim"
                grid="6"
                label="Data final do acompanhamento"
                :required="verificaDataInicial"
                :min-date="data_inicio"
                :max-date="dataNow"
              />

              <form-calendar
                v-model="data_avaliacao_inicio"
                grid="6"
                label="Data de Avaliação (De)"
                :max-date="data_avaliacao_final"
              />

              <form-calendar
                v-model="data_avaliacao_final"
                grid="6"
                label="Data de Avaliação (Até)"
                :min-date="data_avaliacao_inicio"
              />

            </template>

            <form-toggle
              v-model="filtrarOutros"
              grid="12"
              label="Filtrar por Serviços, Vulnerabilidade ou Violências?"
            />
            <template v-if="filtrarOutros">
              <form-select
                v-model="filtroServicos"
                label="Filtrar por Serviço"
                grid="12"
                :itens="servicos"
                :disabled="loadingSearchTipos"
                :loading="loadingSearchTipos"
                multiple
              />

              <form-select
                v-model="filtroVulnerabilidades"
                label="Vulnerabilidades"
                :itens="vulnerabilidades"
                :disabled="loadingVulnerabilidades"
                :loading="loadingVulnerabilidades"
                :multiple="true"
              />

              <form-select
                v-model="filtroViolencias"
                label="Violências"
                :itens="violencias"
                :disabled="loadingViolencias"
                :loading="loadingViolencias"
                :multiple="true"
              />

            </template>
          </div>
          <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
            <div class="col-auto px-2 text-right">
              <button
                class="btn btn-default"
                @click.prevent="limparFiltros(), (viewFilterReport = false)"
              >
                <i class="fas fa-times"></i>
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="limparFiltros()"
              >
                {{ $t("Limpar Filtros") }}
              </button>

              <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                type="submit"
              >
                <i class="fas fa-chart-bar"></i>
                {{ $t("Gerar Relatório") }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <loading-report
        :loading="isLoadingMsg"
        mensagem="Por favor aguarde estamos realizando sua solicitação..."
        icone="fa-smile-wink"
      ></loading-report>

      <loading-animation
        :active.sync="loading"
        :is-full-page="false"
        :opacity="1"
        color="#5895FF"
      />
      <div class="col-12" id="boxPrint">
        <print-content>
          <template v-slot:datas>
            <p class="d-flex align-items-center justify-content-between mb-4">
              <span
                >Período selecionado:
                <b>{{ datas.start }} - {{ datas.end }}</b>
                <b-link
                  href="#"
                  @click.prevent="void 0"
                  class="mb-2"
                  variant="info"
                  v-b-popover.hover.top="
                    'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                  "
                >
                  <i class="fas fa-info-circle"></i> </b-link
              ></span>

              <span v-if="pagination.total"
                >Total de Registros <b>{{ pagination.total }}</b
                >, total por página <b>{{ pagination.perPage }}</b></span
              >

              <span>
                <a v-if="!showName" @click.prevent="mostrarNome" href="#"
                  ><i class="fas fa-eye"></i> Mostrar Nome de Registro</a
                >
                <a v-else @click.prevent="ocultarNome" href="#"
                  ><i class="fas fa-eye-slash"></i> Ocultar Nome de Registro</a
                >
              </span>
            </p>
          </template>
          <b-table
            :fields="[
              {
                key: 'protocolo',
                label: $t('Detalhes'),
              },
              {
                key: 'data_avaliacao',
                label: $t('Datas'),
              },
              {
                key: 'status_nome',
                label: $t('Status'),
              },
              {
                key: 'actions',
                label: '',
                class: 'text-right no-print',
                thStyle: {
                  width: '95px',
                  minWidth: '95px',
                },
              },
            ]"
            :items="AcompanhamentosList"
            :responsive="true"
            striped
            hover
            show-empty
            small
            outlined
            stacked="xs"
            table-class="mb-3"
          >
            <template v-slot:cell(protocolo)="data">
              RF:
              <strong v-if="data.item.reponsavel_familiar.nome_social">
                {{ data.item.reponsavel_familiar.nome_social }} ( N.R.: )
                <span v-if="showName">
                  {{ data.item.reponsavel_familiar.nome_completo }}
                </span>
              </strong>
              <strong v-else>{{
                data.item.reponsavel_familiar.nome_completo
              }}</strong>
              <br />
              Serviço: <b>{{ data.item.servico }}</b>
              <br />
              Protocolo: <b>{{ data.item.protocolo }}</b>
              <br />
              Unidade:
              <b>{{ data.item.unidade ? data.item.unidade.nome : "" }}</b>
              <br />
              Técnico:
              <b>{{ data.item.responsavel.nome }}</b> -
              <span>
                {{ data.item.responsavel.profissao ?? "Não informado" }}
              </span>
              <br />
              <i
                class="mdi mdi-lock mdi-18px text-danger"
                v-if="data.item.privado == 1"
                v-b-popover.hover.top="'Acompanhamento com sigilo'"
              ></i>

              <small
                class="d-block text-muted"
                v-if="
                  data.item.vulnerabilidades &&
                  data.item.vulnerabilidades.length > 0
                "
              >
                Vulnerabilidades
                <ul>
                  <li
                    v-for="vulnerabilidade in data.item.vulnerabilidades"
                    :key="vulnerabilidade.id"
                  >
                    <strong>{{ vulnerabilidade.descricao | toUpper }}</strong>
                  </li>
                </ul>
              </small>
            </template>
            <template v-slot:cell(data_avaliacao)="data">
              <span class="d-block small">
                Período:<br />
                <strong>
                  {{ data.item.dataIngresso }} à
                  {{ data.item.dataFinal }}
                </strong>
              </span>
              <span class="d-block small">
                Avaliação:<br /><strong>{{ data.item.dataAvaliacao }}</strong>
              </span>
              <span class="d-block small">
                Criado em:<br /><strong>{{ data.item.cadastrado }}</strong>
              </span>
              <span class="d-block small">
                Atualizado em:<br /><strong>{{ data.item.atualizado }}</strong>
              </span>
            </template>
            <template v-slot:cell(status_nome)="data">
              <span class="small" v-html="data.item.status_nome"></span>
            </template>
            <template v-slot:cell()="data">
              <button
                v-if="data.item.is_owner"
                @click="
                  redirectAcompanhamento(data.item.id, data.item.id_familia)
                "
                class="px-2 mb-0 btn btn-sm btn-success"
              >
                <i class="mdi mdi-square-edit-outline" />
              </button>
              <button
                v-else
                @click="showAcompanhamento(data.item.id, data.item.id_familia)"
                class="px-2 mb-0 btn btn-sm btn-primary"
              >
                <i class="mdi mdi-eye" />
              </button>
            </template>
            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                  :alt="$t('No results')"
                  class="mb-5"
                  src="/img/icons/robot.svg"
                  style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </print-content>
        <div class="row align-items-center no-print">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                v-on:change="getAnalytics"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }}
              {{ pagination.currentPage }}
              {{ $t("of") }}
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>

        <div class="box-btn-print no-print">
          <b-button
            v-if="!loading"
            :title="$t('Visualizar e Imprimir')"
            class="py-2"
            size="sm"
            type="button"
            v-b-tooltip.hover
            variant="primary"
            @click="print()"
          >
            <i class="fas fa-print"></i>
          </b-button>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { toUpper } from "lodash";

export default {
  name: "HomeAcompanhamentos",
  data() {
    return {
      showName: false,
      loading: true,
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTecnicos: true,
      loadingSearchTipos: true,
      range: "yearly",
      AcompanhamentosList: [],
      unidades: [],
      page: 1,
      search: "",
      perPage: 10,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      filtros: {
        unidade: null,
      },
      tecnicos: [],
      servicos: [],
      isLoadingMsg: false,
      filter: false,
      user_id: null,
      tecnico_id: null,
      unidade_id: null,
      role: null,
      loadingStatus: false,
      datas: [],

      filtroUnidades: [],
      filtroTecnicos: [],
      filtroTecnicosAutor: [],
      filtroServicos: [],
      filtroStatus: [],
      filtroVulnerabilidades: [],
      filtroViolencias: [],
      loadingViolencias: [],
      violencias: [],
      vulnerabilidades: [],
      filtrarDatas: false,
      filtrarOutros: false,
      filtroDatas: [],
      filtroDatasAvaliacao: [],
    };
  },
  mounted() {
    this.getVulnerabilidades();
    this.getViolencias();
    this.getStatus();
    this.getServicos();
    this.getTecnicos();
    this.getUnidades();
    this.getAnalytics();
  },

  computed: {
    listtecnicos() {
      const pessoas = this.tecnicos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value:
          " <b>" +
          elem.value +
          "</b> - " +
          (elem.profissao ?? "Não informado") +
          " - " +
          elem.nome_unidade,
      }));
      return map;
    },
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    filterData(value) {
      return this.$options.filters.formatDateHora(value);
    },
    updateAnalytics(range) {
      if (this.range !== range) {
        this.range = range;
        this.getAnalytics();
      }
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getAnalytics();
      }
    },
    getAnalytics() {
      this.isLoadingMsg = true;
      this.loading = true;

      this.filtroDatas = [];

      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }

      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      this.filtroDatasAvaliacao = [];

      if (this.data_avaliacao_inicio) {
        this.filtroDatasAvaliacao.push(
          this.$options.filters.formatDateYMD(this.data_avaliacao_inicio)
        );
      }

      if (this.data_avaliacao_final) {
        this.filtroDatasAvaliacao.push(
          this.$options.filters.formatDateYMD(this.data_avaliacao_final)
        );
      }

      axios
        .get("api/dashboard/report/acompanhamentos/home", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            range: this.range,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            filtroTecnicosAutor: this.filtroTecnicosAutor,
            filtroServicos: this.filtroServicos,
            filtroStatus: this.filtroStatus,
            filtroVulnerabilidades: this.filtroVulnerabilidades,
            filtroViolencias: this.filtroViolencias,
            filtroDatas: this.filtroDatas,
            filtroDatasAvaliacao: this.filtroDatasAvaliacao,
          },
        })
        .then((response) => {
          this.loading = false;

          this.user_id = this.$store.state.user.id;
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.unidade_id = this.$store.state.unidade;
          this.role = this.$store.state.user.role;

          this.datas = response.data.datas;
          this.AcompanhamentosList = response.data.dados;
          this.pagination = response.data.pagination;

          // TypeError: Cannot read properties of null (reading 'id')
          // retirar vulnerabilidades
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getAnalytics();
          } else {
            this.isLoadingMsg = false;
            this.loading = false;
          }
        })
        .catch(() => {
          this.isLoadingMsg = false;
          this.loading = false;
        });
    },
    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    getTecnicos() {
      this.tecnicos = [];
      this.loadingSearchTecnicos = true;
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`, {
          params: {
            unidades: this.filtroUnidades,
          },
        })
        .then((response) => {
          this.tecnicos = response.data;
        })
        .finally(() => (this.loadingSearchTecnicos = false));
    },
    getServicos() {
      this.loadingSearchTipos = true;
      axios
        .get(`api/dashboard/report/acompanhamentos/servicos`)
        .then((response) => {
          this.servicos = response.data;
        })
        .finally(() => {
          this.loadingSearchTipos = false;
        });
    },
    getStatus() {
      this.loadingStatus = true;
      axios
        .get(`api/dashboard/report/status/acompanhamento`)
        .then((response) => {
          this.status = response.data;
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },

    redirectAcompanhamento(id, familia_id) {
      var id_familia = familia_id.id != undefined ? familia_id.id : familia_id;

      const url = this.$router.resolve({
        path: `/dashboard/acompanhamento/edit/${id}`,
        query: { familia_id: id_familia },
      }).href;

      window.open(url, '_blank');
    },
    showAcompanhamento(id, familia_id) {
      var id_familia = familia_id.id != undefined ? familia_id.id : familia_id;
      const url = this.$router.resolve({
        path: `/dashboard/acompanhamento/show/${id}`,
        query: { familia_id: id_familia },
      }).href;

      window.open(url, '_blank');
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/report/acompanhamentos/home", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            range: this.range,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            filtroTecnicosAutor: this.filtroTecnicosAutor,
            filtroServicos: this.filtroServicos,
            filtroStatus: this.filtroStatus,
            filtroVulnerabilidades: this.filtroVulnerabilidades,
            filtroViolencias: this.filtroViolencias,
            filtroDatas: this.filtroDatas,
            filtroDatasAvaliacao: this.filtroDatasAvaliacao,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    limparFiltros() {
      this.filtros = {};
      this.data_inicio = "";
      this.data_fim = "";
      this.data_avaliacao_inicio = "";
      this.data_avaliacao_final = "";

      this.verificaDataInicial = false;

      this.filtroUnidades = [];
      this.filtroTecnicos = [];
      this.filtroTecnicosAutor = [];
      this.filtroServicos = [];
      this.filtroStatus = [];
      this.filtroVulnerabilidades = [];
      this.filtroViolencias = [];

      this.getAnalytics();
    },

    async getVulnerabilidades() {
      this.loadingVulnerabilidades = true;
      await axios
        .get(`api/dashboard/get/geral/vulnerabilidades`)
        .then((response) => {
          this.vulnerabilidades = response.data;
        })
        .finally(() => {
          this.loadingVulnerabilidades = false;
        });
    },
    async getViolencias() {
      this.loadingViolencias = true;
      await axios
        .get(`api/dashboard/get/violencias`)
        .then((response) => {
          this.violencias = response.data;
          this.loadingViolencias = false;
        })
        .finally(() => {
          this.loadingViolencias = false;
        });
    },
  },
};
</script>
